module.exports = __webpack_public_path__ + "img/tab4.4b6c5b36.png";